const STORAGE_KEY = 'techrabbit_vid';

function randomId() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `v_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
}

export function getOrCreateVisitorId() {
  try {
    const existing = localStorage.getItem(STORAGE_KEY);
    if (existing && existing.length <= 80) return existing;
    const id = randomId();
    localStorage.setItem(STORAGE_KEY, id);
    return id;
  } catch {
    return randomId();
  }
}

export async function trackPageView({ language } = {}) {
  const API_BASE = process.env.REACT_APP_API_URL || '';
  const payload = {
    visitorId: getOrCreateVisitorId(),
    path: `${window.location.pathname}${window.location.hash || ''}` || '/',
    referrer: document.referrer || '',
    language: language || document.documentElement.lang || '',
    userAgent: navigator.userAgent || '',
  };

  try {
    await fetch(`${API_BASE}/api/analytics/pageview`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      keepalive: true,
    });
  } catch {
    // Tracking must never break the site.
  }
}
